import moment from "moment";

export const getAdjustedTime = (elapsedTime: number) => {
  const now = moment.utc();
  return elapsedTime >= 0
    ? now.clone().subtract(Math.abs(elapsedTime), "milliseconds")
    : now.clone().add(Math.abs(elapsedTime), "milliseconds");
};